module.exports = __webpack_public_path__ + "img/img2.2aee3325.png";